/* Shop by Step — automatic label contrast.
   Ported from the approved Cloudflare preview (steps-b.html, variant C).

   The label and the watermark number sit ON the image. Product photography in
   this catalogue is shot on white: measured across all 70 live products in
   these seven collections, the area under the label reads 216-254 out of 255
   on almost every one. A white label disappears on those, so the colour cannot
   be a fixed choice.

   Each tile is sampled once, on load: bottom-left 45% x 28%, mean luminance.
   >= 150 -> dark label over a white scrim.  < 150 -> white label over a dark one.

   The Liquid renders a sensible default first, so the tile is correct before
   this runs and stays correct if it never does (canvas can throw on a tainted
   image). A block set to "Light" or "Dark" explicitly is left alone.
*/
(function () {
  'use strict';

  var THRESHOLD = 150;

  function measure(img) {
    try {
      var W = 120, H = 120;
      var c = document.createElement('canvas');
      c.width = W; c.height = H;
      var x = c.getContext('2d');
      x.drawImage(img, 0, 0, W, H);
      var y0 = Math.round(H * 0.72);
      var w = Math.round(W * 0.45);
      var d = x.getImageData(0, y0, w, H - y0).data;
      var s = 0, n = 0;
      for (var i = 0; i < d.length; i += 4) {
        s += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2];
        n++;
      }
      return s / n;
    } catch (e) {
      return null;                       // tainted or not decodable — keep default
    }
  }

  function apply(tile) {
    var img = tile.querySelector('img');
    if (!img) return;

    function run() {
      var lum = measure(img);
      if (lum === null) return;
      tile.classList.remove('is-light', 'is-dark');
      tile.classList.add(lum >= THRESHOLD ? 'is-light' : 'is-dark');
    }

    if (img.complete && img.naturalWidth > 0) run();
    else img.addEventListener('load', run, { once: true });
  }

  function boot(scope) {
    var tiles = (scope || document).querySelectorAll('[data-step-tile][data-tone="auto"]');
    Array.prototype.forEach.call(tiles, function (t) {
      // crossOrigin must be set before the request for canvas to be readable.
      var img = t.querySelector('img');
      if (img && !img.crossOrigin && !img.complete) img.crossOrigin = 'anonymous';
      apply(t);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
